import {
  faAddressCard,
  faBan,
  faBusinessTime,
  faCircleNotch,
  faExclamation,
  faFrown,
  faMailBulk,
  faPaperPlane,
  faRetweet,
  faShareSquare,
  faTrash,
  faTruck,
  faUndo,
  faCreditCard,
  faSync,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const exportLabels = {
  "AR COURRIER": "AR TRANSPORTADORA",
  "AR INDIVIDUAL": "AR INDIVIDUAL",
  "AR LOTE": "AR LOTE",
  "AR MESTRE": "AR MESTRE",
  BAIRRO: "BAIRRO",
  CEP: "CEP",
  CIDADE: "CIDADE",
  "CNPJ CLIENTE": "CNPJ CLIENTE",
  "CNPJ FILIAL": "CNPJ FILIAL",
  "COD PLASTICO": "COD PLASTICO",
  COMPLEMENTO: "COMPLEMENTO",
  CONTRATO: "CONTRATO",
  CPF: "CPF",
  CLASSIFICACAO: "CLASSIFICACAO",
  "DATA CADASTRO FVS": "DATA CADASTRO FVS",
  "DATA ENTREGA": "DATA ENTREGA",
  "DATA MOVIMENTO": "DATA MOVIMENTO",
  "DATA PEDIDO": "DATA PEDIDO",
  "DATA EXPEDIÇÃO": "DATA EXPEDIÇÃO",
  "DATA PROCESSAMENTO FVS": "DATA PROCESSAMENTO FVS",
  "DATA ULTIMA ATUALIZACAO": "DATA ULTIMA ATUALIZACAO",
  DESTINATARIO: "DESTINATARIO",
  "EMAIL COLABORADOR": "EMAIL COLABORADOR",
  "EMAIL 1": "EMAIL 1",
  "EMAIL 2": "EMAIL 2",
  "EMAIL 3": "EMAIL 3",
  FABRICA: "FABRICA",
  EMPRESA: "EMPRESA",
  "PREVISAO ENTREGA": "PREVISAO ENTREGA",
  "FILIAL ENTREGA": "FILIAL ENTREGA",
  "ID LOTE": "ID LOTE",
  "INTERLOCUTOR 1": "INTERLOCUTOR 1",
  "INTERLOCUTOR 2": "INTERLOCUTOR 2",
  "INTERLOCUTOR 3": "INTERLOCUTOR 3",
  MATRICULA: "MATRICULA",
  "NOME USUARIO": "NOME USUARIO",
  NUMERO: "NUMERO",
  "PEDIDO FVS": "PEDIDO FVS",
  "PEDIDO WEB": "PEDIDO WEB",
  PREMIUM: "PREMIUM",
  PRODUTO: "PRODUTO",
  "QTD CARTOES": "QTD CARTOES",
  RUA: "RUA",
  SITUACAO: "SITUACAO",
  "STATUS SAFRA": "STATUS SAFRA",
  "SUB REGIAO": "SUB REGIAO",
  "SLA DIAS": "SLA DIAS",
  "TEL COLABORADOR": "TEL COLABORADOR",
  "TEL EMPRESA": "TEL EMPRESA",
  "TEL INTERLOCUTOR 1": "TEL INTERLOCUTOR 1",
  "TEL INTERLOCUTOR 2": "TEL INTERLOCUTOR 2",
  "TEL INTERLOCUTOR 3": "TEL INTERLOCUTOR 3",
  "TIPO ENTREGA": "TIPO ENTREGA",
  "TIPO EMISSAO": "TIPO EMISSAO",
  "QTD TENTATIVAS": "QTD TENTATIVAS",
  TRANSPORTADORA: "TRANSPORTADORA",
  UF: "UF",
  LOTE: "LOTE",
}

export const getStatusSafraList = () => {
  let statusSafra = []
  statusSafra.push({ id: "16, 17, 25, 29", name: "Em produção" })
  statusSafra.push({
    id: "1, 2, 3, 13, 14, 15, 18, 21",
    name: "Em fluxo de transporte",
  })

  statusSafra.push({ id: 5, name: "Saiu pra entrega" })
  statusSafra.push({ id: "6, 19, 22, 28", name: "Entregue" })
  statusSafra.push({ id: 8, name: "Aguardando Retirada - Correios" })
  statusSafra.push({ id: "7, 10", name: "Em devolução" })
  statusSafra.push({ id: 12, name: "Em Custódia" })
  statusSafra.push({ id: 4, name: "Extraviado" })
  statusSafra.push({ id: 11, name: "Incinerado" })
  statusSafra.push({ id: "23, 24", name: "Fora do fluxo padrão" })
  statusSafra.push({ id: "9, 20, 26, 27", name: "Fluxo cancelado" })
  return statusSafra
}

export const badgesClass = {
  1: "bg-success",
  2: "bg-info",
  3: "bg-info",
  4: "bg-danger",
  5: "bg-success",
  6: "bg-success",
  7: "bg-warning",
  8: "bg-info",
  9: "bg-danger",
  10: "bg-warning",
  11: "bg-danger",
  12: "bg-danger",
  13: "bg-info",
  14: "bg-info",
  15: "bg-danger",
  16: "bg-info",
  17: "bg-info",
  18: "bg-info",
  19: "bg-info",
  20: "bg-danger",
  21: "bg-info",
  22: "bg-info",
  23: "bg-warning",
  24: "bg-danger",
  25: "bg-info",
  26: "bg-danger",
  27: "bg-info",
  28: "bg-info",
}

export const getBadgeClass = id => {
  return badgesClass[id] || "bg-info"
}

export const courierClass = {
  1: "bg-warning",
  2: "bg-secondary",
  3: "bg-success",
  4: "bg-info",
}

// export const getIcon = statusId => {
//   const icons = {
//     2: "bx-paper-plane",
//     3: "bx-transfer",
//     5: "bxs-truck",
//     6: "bx-check-circle",
//     7: "bx-undo",
//     10: "bx-edit",
//     12: "bxs-hourglass",
//     15: "bx-x-circle",
//     25: "bxs-factory",
//   }
//   return icons[Number(statusId)] || "bx-transfer"
// }

export const getIcon = id => {
  const icons = {
    1: faAddressCard,
    1: faAddressCard,
    2: faPaperPlane,
    3: faShareSquare,
    5: faTruck,
    6: faMailBulk,
    11: faTrash,
    4: faTrash,
    7: faUndo,
    9: faTrash,
    13: faMailBulk,
    15: faFrown,
    24: faBan,
    8: faBusinessTime,
    12: faBusinessTime,
    14: faRetweet,
    27: faSync,
    28: faCreditCard,
  }
  return icons[id] || faExclamation
}

export const getFlashPDF = flashPDF => {
  if (flashPDF?.loading) {
    return (
      <>
        {" "}
        / <FontAwesomeIcon icon={faCircleNotch} spin size="1x" color="#000" />
      </>
    )
  }
  if (flashPDF.status) {
    const openInNewTab = pdf => {
      let win = window.open()

      const uint8Array = new Uint8Array(pdf.data)
      const blob = new Blob([uint8Array], { type: "application/pdf" })
      const url = URL.createObjectURL(blob)
      win.document.write(
        '<iframe src="' +
          url +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      )
    }
    return (
      <>
        <a
          style={{ display: "table-cell", color: "green" }}
          className="ps-5"
          onClick={() => {
            openInNewTab(flashPDF.pdf)
          }}
        >
          Ar Digital
        </a>
      </>
    )
  } else {
    return ` \\ ${flashPDF.text}`
  }
}

export const getLocalName = (
  rawInfo,
  status,
  shippingLocal,
  order,
  externalEventId
) => {
  if (externalEventId == 2200) {
  }
  const _rawInfo = JSON.parse(rawInfo || "{}")
  if (Object.hasOwn(_rawInfo, "dtHrCriado")) {
    try {
      if (shippingLocal == "null - null") {
        shippingLocal = " "
      }
      // const _rawInfo = JSON.parse(rawInfo)

      const code = `${_rawInfo.codigo}_${_rawInfo.tipo}`
      if (
        _rawInfo.unidade.endereco &&
        [
          "LDI_00",
          "LDI_01",
          "LDI_02",
          "LDI_03",
          "LDI_14",
          "BDE_24",
          "BDR_24",
          "BDI_24",
          "BDR_54",
          "BDI_54",
          "BDE_54",
          "BDE_55",
          "BDR_55",
          "BDI_55",
          "BDE_58",
          "BDI_58",
          "BDR_58",
          "BDE_59",
          "BDI_59",
          "BDR_59",
        ].indexOf(code) >= 0
      ) {
        const endereco = _rawInfo.unidade.endereco

        return `${endereco.logradouro || ""} - ${endereco.numero || ""}, ${
          endereco.bairro || ""
        } - ${endereco.cidade || ""}/${endereco.uf || ""}`
      }
    } catch (error) {}

    try {
      const transport = order.shippingCompany.name
      if (
        status.name == "Encaminhado para os Correios" &&
        transport == "InterLog"
      ) {
        return _rawInfo.codentregacorreio
      }
      if (
        status.name == "Encaminhado para os Correios" &&
        transport == "Flash"
      ) {
        const arCorreios = _rawInfo.numEncTer ? (
          externalEventId == 2200 ? (
            <a
              href="https://rastreamento.correios.com.br/app/index.php"
              target="_blank"
            >
              {_rawInfo.numEncTer}
            </a>
          ) : (
            _rawInfo.numEncTer
          )
        ) : (
          "Sem número"
        )
        return arCorreios
      }
    } catch (error) {}
    return shippingLocal || status?.name
  } else {
    try {
      if (shippingLocal == "null - null") {
        shippingLocal = " "
      }
      const code = `${_rawInfo.tipo}_${_rawInfo.status}`
      if (
        _rawInfo.endereco &&
        [
          "LDI_00",
          "LDI_01",
          "LDI_02",
          "LDI_03",
          "LDI_14",
          "BDE_24",
          "BDR_24",
          "BDI_24",
          "BDR_54",
          "BDI_54",
          "BDE_54",
          "BDE_55",
          "BDR_55",
          "BDI_55",
          "BDE_58",
          "BDI_58",
          "BDR_58",
          "BDE_59",
          "BDI_59",
          "BDR_59",
        ].indexOf(code) >= 0
      ) {
        const endereco = _rawInfo.endereco[0]

        return `${endereco.logradouro[0]} - ${endereco.numero[0]}, ${endereco.bairro[0]} - ${endereco.localidade[0]}/${endereco.uf[0]}`
      }
    } catch (error) {}

    try {
      // const _rawInfo = JSON.parse(rawInfo)
      const transport = order.shippingCompany.name
      if (
        status.name == "Encaminhado para os Correios" &&
        transport == "InterLog"
      ) {
        const arCorreios = _rawInfo.arCorreios ? (
          externalEventId == 2200 ? (
            <a
              href="https://rastreamento.correios.com.br/app/index.php"
              target="_blank"
            >
              {_rawInfo.arCorreios}
            </a>
          ) : (
            _rawInfo.arCorreios
          )
        ) : (
          "Sem número"
        )
        return arCorreios
        //return _rawInfo.codentregacorreio
      }
      if (
        status.name == "Encaminhado para os Correios" &&
        transport == "Flash"
      ) {
        const arCorreios = _rawInfo.numEncTer ? (
          externalEventId == 2200 ? (
            <a
              href="https://rastreamento.correios.com.br/app/index.php"
              target="_blank"
            >
              {_rawInfo.numEncTer}
            </a>
          ) : (
            _rawInfo.numEncTer
          )
        ) : (
          "Sem número"
        )
        return arCorreios
      }
    } catch (error) {}
    return shippingLocal || status?.name
  }
}
